





































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { dateFormat } from "@/utils/timeFormat";
import {
  staffList,
  getSelectClassList,
  getSelectCourseList,
  autoSearchData,
  getSeleSubjectsList,
} from "@/api/globalSearch";
import { exportLoop } from "@/utils/export";
import {
  rollCallList,
  exportRollList,
  exportRollListClss,
  lessonCancelRollCall,
} from "@/api/rollCallRecord";
import { PageModule } from "@/store/module/page";
import { classroomSelectListApi } from "@/api/classRoom";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    commonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo = {
    consume_number_start: "",
    consume_number_end: "",
    real_consume_number_start: "",
    real_consume_number_end: "",
    course_type: -1,
    status_type: -1,
    sort_field: "lesson_full_start_time",
    sort_type: "desc",
    teacher_id: "" as number | string,
    teacher_list: [] as any[],
    classroom_id: "" as number | string,
    roll_call_date: [] as string[],
    lesson_date: [] as string[],
    subject_ids: [] as number[],
    lesson_id: "", // 上课内容id
    follow_staff_id: "",
    follow_staff_list: [],
  }; //搜索数据
  searchClassRoomList: {
    classroom_id: number;
    name: string;
  }[] = [];
  tableData = []; //列表数据
  page = 1;
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  total = 0;
  staffName = "";
  courseName = ""; //课程名字
  className = ""; //班级名字
  teacherName = "";
  subjectsList: any[] = [];
  loaded = false;
  weekList: {
    key: number;
    value: string;
  }[] = [
    {
      key: 1,
      value: "周一",
    },
    {
      key: 2,
      value: "周二",
    },
    {
      key: 3,
      value: "周三",
    },
    {
      key: 4,
      value: "周四",
    },
    {
      key: 5,
      value: "周五",
    },
    {
      key: 6,
      value: "周六",
    },
    {
      key: 0,
      value: "周日",
    },
  ];
  created() {
    if (
      this.$route.query.name === "week" ||
      this.$route.query.name === "month"
    ) {
      this.searchInfo.lesson_date[0] = this.$route.query.s_time;
      this.searchInfo.lesson_date[1] = this.$route.query.e_time;
    }
    if (this.$route.query.tid) {
      this.searchInfo.teacher_id = Number(this.$route.query.tid);
      this.searchInfo.status_type = 1;
    }
    classroomSelectListApi({
      page: 1,
      page_size: 1000,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.searchClassRoomList = res.data.list;
      }
    });
  }
  mounted() {
    if (PageModule.latestRoute === "rollCallDetails") {
      // 详情返回
      const cache = PageModule.pageInfo.rollCallRecordList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    }
    if (this.$route.query.tab == "rollCallRecord") {
      if (PageModule.latestRoute === "dashboard") {
        // 来自首页
        const params = this.$route.params;
        if (params.lesson_date_start && params.lesson_date_end) {
          this.searchInfo.lesson_date = [
            params.lesson_date_start,
            params.lesson_date_end,
          ];
        }
      } else if (PageModule.latestRoute === null) {
        // 新开页面或者刷新后
        // 来自工资绩效页
        const salaryCache = sessionStorage.getItem(
          "salary-achievements-link-to-rollcall-list"
        );
        if (salaryCache) {
          const cache: {
            teacher_id?: number;
            teacher_name?: string;
            lesson_date?: string[];
            course_type?: number;
          } = JSON.parse(salaryCache);
          if (cache.teacher_id && cache.teacher_name) {
            this.searchInfo.teacher_id = cache.teacher_id;
            this.searchInfo.teacher_list = [
              {
                staff_id: cache.teacher_id,
                name: cache.teacher_name,
              },
            ];
          }
          if (cache.lesson_date) {
            this.searchInfo.lesson_date = cache.lesson_date;
          }
          if (cache.course_type) {
            this.searchInfo.course_type = cache.course_type;
          }
          sessionStorage.removeItem(
            "salary-achievements-link-to-rollcall-list"
          );
        }
      }
    }
    const table: any = this.$refs.mainTable;
    table.sort(
      this.searchInfo.sort_field,
      this.searchInfo.sort_type === "asc" ? "ascending" : "descending"
    );
    this.globalSearch("", "course");
    this.globalSearch("", "class");
    this.globalSearch("", "subject");
  }
  getTime(e: any) {
    const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
    const v = "（周" + weekZh[e.getDay()] + "）";
    const format = dateFormat("YYYY-mm-dd HH:MM", e);
    return format.slice(0, 10) + v + format.slice(11);
  }
  handleSortChange(data: { prop: string; order: string }) {
    this.searchInfo.sort_field = data.prop;
    if (data.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (data.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getClasslistData({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  // 导出开始
  clickexport() {
    const _t = this as any;
    const data: any = {};
    if (_t.searchInfo.class_id) {
      data.class_id = _t.searchInfo.class_id;
    }
    if (_t.searchInfo.teacher_id) {
      data.teacher_id = _t.searchInfo.teacher_id;
    }
    if (_t.searchInfo.course_id) {
      data.course_id = _t.searchInfo.course_id;
    }
    if (_t.searchInfo.staff_id) {
      data.staff_id = _t.searchInfo.staff_id;
    }
    if (
      _t.searchInfo.roll_call_date &&
      _t.searchInfo.roll_call_date.length === 2
    ) {
      data.roll_call_start_date = _t.searchInfo.roll_call_date[0];
      data.roll_call_end_date = _t.searchInfo.roll_call_date[1];
    }
    if (_t.searchInfo.lesson_date && _t.searchInfo.lesson_date.length === 2) {
      data.lesson_start_date = _t.searchInfo.lesson_date[0];
      data.lesson_end_date = _t.searchInfo.lesson_date[1];
    }
    if (_t.searchInfo.course_type > -1) {
      data.course_type = _t.searchInfo.course_type;
    }
    if (_t.searchInfo.subject_ids && _t.searchInfo.subject_ids.length > 0) {
      data.subject_ids = _t.searchInfo.subject_ids;
    }
    if (_t.searchInfo.lesson_id) {
      data.lesson_id = _t.searchInfo.lesson_id;
    }
    if (_t.searchInfo.week_day === 0 || _t.searchInfo.week_day) {
      data.week_day = _t.searchInfo.week_day;
    } else {
      data.week_day = -1;
    }
    exportRollListClss(data).then((res: any) => {
      if (res.error_code == 0) {
        exportLoop(res.data.task_id);
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  lookDetailsrollist(e: any) {
    const _t = this;
    PageModule.SET_PAGE_INFO({
      name: "rollCallRecordList",
      key: "search_info",
      value: _t.searchInfo,
    });
    PageModule.SET_PAGE_INFO({
      name: "rollCallRecordList",
      key: "page",
      value: _t.page,
    });
    PageModule.SET_PAGE_INFO({
      name: "rollCallRecordList",
      key: "page_size",
      value: _t.pageSize,
    });
    _t.$router.push({ name: "rollCallDetails", query: { id: e.roll_call_id } });
  }
  // 通用搜索框
  getSelectrList(e: string) {
    const _t = this as any;
    _t.globalSearch("", e);
  }
  getglobalsearchdata(data: autoSearchData, type: String) {
    if (type == "staff") {
      return staffList(data);
    } else if (type == "teacher") {
      data.job_ids = [1];
      return staffList(data);
    } else if (type == "class") {
      return getSelectClassList(data);
    } else if (type == "course") {
      return getSelectCourseList(data);
    } else if (type == "subject") {
      return getSeleSubjectsList(data);
    }
  }
  async globalSearch(queryString: string, type: string) {
    const _t = this;
    let data: autoSearchData = {
      page: 1,
      page_size: 100,
    };
    let restaurants: any = {};
    if (queryString) {
      data = {
        page: 1,
        page_size: 10,
      };
      if (type == "class") {
        data.name = queryString;
      } else if (type == "course" || type == "subject") {
        data.title = queryString;
      } else {
        data.key_word = queryString;
      }
    }
    if (type == "subject") {
      data.page_size = 500;
    }
    restaurants = await _t.getglobalsearchdata(data, type);
    const list = restaurants.data.list;
    if (type == "staff") {
      _t.staffName = list;
    } else if (type == "teacher") {
      _t.teacherName = list;
    } else if (type == "class") {
      _t.className = list;
    } else if (type == "course") {
      _t.courseName = list;
    } else if (type == "subject") {
      _t.subjectsList = list;
    }
  }
  //上课记录
  getClasslistData(data: any) {
    const _t = this as any;
    if (_t.searchInfo.class_id) {
      data.class_id = _t.searchInfo.class_id;
    }
    if (_t.searchInfo.sort_field) {
      data.sort_field = _t.searchInfo.sort_field;
    }
    if (_t.searchInfo.sort_type) {
      data.sort_type = _t.searchInfo.sort_type;
    }
    if (_t.searchInfo.teacher_id) {
      data.teacher_id = _t.searchInfo.teacher_id;
    }
    if (_t.searchInfo.course_id) {
      data.course_id = _t.searchInfo.course_id;
    }
    if (_t.searchInfo.class_id) {
      data.class_id = _t.searchInfo.class_id;
    }
    if (_t.searchInfo.follow_staff_id) {
      data.staff_id = _t.searchInfo.follow_staff_id;
    }
    if (_t.searchInfo.consume_number_start) {
      data.consume_number_start = _t.searchInfo.consume_number_start;
    }
    if (_t.searchInfo.consume_number_end) {
      data.consume_number_end = _t.searchInfo.consume_number_end;
    }
    if (_t.searchInfo.real_consume_number_start) {
      data.real_consume_number_start = _t.searchInfo.real_consume_number_start;
    }
    if (_t.searchInfo.real_consume_number_end) {
      data.real_consume_number_end = _t.searchInfo.real_consume_number_end;
    }
    if (
      _t.searchInfo.roll_call_date &&
      _t.searchInfo.roll_call_date.length === 2
    ) {
      data.roll_call_start_date = _t.searchInfo.roll_call_date[0];
      data.roll_call_end_date = _t.searchInfo.roll_call_date[1];
    }
    if (_t.searchInfo.lesson_date && _t.searchInfo.lesson_date.length === 2) {
      data.lesson_start_date = _t.searchInfo.lesson_date[0];
      data.lesson_end_date = _t.searchInfo.lesson_date[1];
    }
    if (_t.searchInfo.course_type > -1) {
      data.course_type = _t.searchInfo.course_type;
    }
    if (_t.searchInfo.subject_ids && _t.searchInfo.subject_ids.length > 0) {
      data.subject_ids = _t.searchInfo.subject_ids;
    }
    if (_t.searchInfo.status_type > -1) {
      data.status = _t.searchInfo.status_type;
    }
    if (_t.searchInfo.classroom_id) {
      data.classroom_id = _t.searchInfo.classroom_id;
    }
    if (_t.searchInfo.week_day === 0 || _t.searchInfo.week_day) {
      data.week_day = _t.searchInfo.week_day;
    } else {
      data.week_day = -1;
    }
    rollCallList(data).then((res: any) => {
      if (res.error_code == 0) {
        res.data.list.map((item: any) => {
          const i = new Date(item.lesson_date.replace(/-/g, "/")).getDay();
          item.weekZh = ["日", "一", "二", "三", "四", "五", "六"][
            item.week_day
          ];
        });
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
        if (!this.loaded) {
          this.loaded = true;
        }
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handleEdit(e: any, t: number) {
    let value = e.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
    value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    if (t === 1) {
      this.searchInfo.consume_number_start = value;
    } else if (t === 2) {
      this.searchInfo.consume_number_end = value;
    } else if (t === 3) {
      this.searchInfo.real_consume_number_start = value;
    } else {
      this.searchInfo.real_consume_number_end = value;
    }
  }
  consumeNumberCheck() {
    if (
      this.searchInfo.consume_number_start &&
      this.searchInfo.consume_number_end
    ) {
      if (
        Number(this.searchInfo.consume_number_start) >
        Number(this.searchInfo.consume_number_end)
      ) {
        this.$message({
          type: "warning",
          message: "排课课时输入有误",
        });
        this.searchInfo.consume_number_end =
          this.searchInfo.consume_number_start;
        return false;
      }
      this.getClasslistData({
        page: 1,
        page_size: this.pageSize,
      });
    } else {
      this.getClasslistData({
        page: 1,
        page_size: this.pageSize,
      });
    }
  }
  realConsumeNumberCheck() {
    if (
      this.searchInfo.real_consume_number_start &&
      this.searchInfo.real_consume_number_end
    ) {
      if (
        Number(this.searchInfo.real_consume_number_start) >
        Number(this.searchInfo.real_consume_number_end)
      ) {
        this.$message({
          type: "warning",
          message: "耗课数输入有误",
        });
        this.searchInfo.real_consume_number_end =
          this.searchInfo.real_consume_number_start;
        return false;
      }
      this.getClasslistData({
        page: 1,
        page_size: this.pageSize,
      });
    } else {
      this.getClasslistData({
        page: 1,
        page_size: this.pageSize,
      });
    }
  }
  handleSearch() {
    const _t = this as any;
    _t.getClasslistData({
      page: 1,
      page_size: _t.pageSize,
    });
  }
  handleSearchReset() {
    this.searchInfo = {
      consume_number_start: "",
      consume_number_end: "",
      real_consume_number_start: "",
      real_consume_number_end: "",
      course_type: -1,
      status_type: -1,
      sort_field: "lesson_full_start_time",
      sort_type: "desc",
      teacher_id: "",
      teacher_list: [],
      classroom_id: "",
      roll_call_date: [],
      lesson_date: [],
      subject_ids: [],
      lesson_id: "",
      follow_staff_id: "",
      follow_staff_list: [],
    };
    this.handleSearch();
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getClasslistData({
      page: 1,
      page_size: e,
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getClasslistData({
      page: e,
      page_size: this.pageSize,
    });
  }
  delRollCall(rollCallInfo: any) {
    this.$confirm(
      `撤销点名记录后，将退还未结课学员课时及金额，确定要撤销点名？`,
      `撤销点名 - ${rollCallInfo.class.name}`,
      {
        customClass: "five-hundred-width",
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        lessonCancelRollCall({
          roll_call_id: rollCallInfo.roll_call_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.$message({
              message: "撤销成功",
              type: "success",
            });
            this.getClasslistData({
              page: this.page,
              page_size: this.pageSize,
            });
          }
        });
      })
      .catch(() => {});
  }
}
